export const environment = {
  production: false,
  siteUrl: "https://digitalimagingeurope.dev.mypepsico.com",
  apiUrl: "https://digitalimagingeurope.dev.mypepsico.com",
  isAmesaApp: false,
  documentViewerUrl: "https://digitalimagingeurope.dev.mypepsico.com/Default.aspx?systemid=",

  apiBaseUrl: "https://digitalimagingapieur.dev.azure.intra.pepsico.com",
  documentViewerBaseUrl: "https://ngdieurviewer.dev.azure.intra.pepsico.com/Default.aspx?systemid=",

  okta: {
    issuer: 'https://secure.ite.pepsico.com/oauth2/default',
    clientId: '0oa2e440ziiojBnWa0h8',
    redirectUri: 'https://digitalimagingeurope.dev.mypepsico.com/callback',
    scopes: ['openid', 'profile'],
    userInfoUrl: 'https://secure.ite.pepsico.com/oauth2/default/v1/userinfo'
  },
  workFlowIds: [14, 12055],
  AmesaSysId: "8000",
  ExceptionQueueIds: "0",
  RejectedQueue: "0",
  ApprovedQueue: "0",
  WaitingForApprovalQueueIds: "31, 90, 199, 233, 291, 325, 470, 507, 625, 662, 733, 770, 841, 878",
  RejectedQueueIdsForAdvance: "0",
};